export default "__VITE_ASSET__Cl0u1JCs__"